import { isObject, isHTMLElement } from "../../js/utilities";
/**
 * Updates the properties of *node* mapping state.attrs and also
 * working with the prop *state.classList* where you can define
 * the classes that you want the those that you don't
 *
 * @param {Object} state
 * @param {HTMLElement} node
 * @returns {void}
 */
const renderHTML = (state, node) => {
    if (isObject(state.attrs)) {
        Object.keys(state.attrs).forEach((attrName) => {
            const newValue = state.attrs[attrName];
            if ((newValue === null || newValue === undefined) && node.hasAttribute(attrName)) {
                node.removeAttribute(attrName);
            } else if (node.getAttribute(attrName) !== newValue) {
                node.setAttribute(attrName, newValue);
            }
        });
    }

    if (Array.isArray(state.classList)) {
        state.classList
            .filter((item) => {
                return typeof item === "string";
            })
            .forEach((style) => {
                const removeStyle = style[0] === "!";
                if (removeStyle) {
                    style = style.substr(1, style.length - 1);
                    if (node.classList.contains(style)) {
                        node.classList.remove(style);
                    }
                } else {
                    if (!node.classList.contains(style)) {
                        node.classList.add(style);
                    }
                }
            });
    }
    return node;
};
/**
 * Returns an object with {attrs,classList} to spread on JSX
 * Removes the items inside classList with "!"
 *
 * @param {Object} state
 * @returns {Object} schema: {attrs:{},classList:[]}
 */
const renderObject = (state) => {
    const stringfyAttrs = (attrs) => {
        return Object.keys(attrs)
            .reduce((result, propName) => {
                result.push(`${propName}="${attrs[propName]}"`);
                return result;
            }, [])
            .join(" ");
    };
    //Make sure to have a attrs as object to spread inside jsx
    const result = {};
    result.attrs = isObject(state.attrs) ? stringfyAttrs(state.attrs) : {};
    result.classList = Array.isArray(state.classList)
        ? state.classList
              .filter((item) => {
                  return typeof item === "string";
              })
              .filter((item) => {
                  return !item.match(/^!/);
              })
        : [];
    return result;
};

/**
 * Updates attributes on HTMLElements or prepare the given **state**
 * to be used inside JSX - in the case you don't provide a **node**
 *
 * @param {Object} state The state object can have the properties:
 *
 * - attrs:{} - object to listing (key:value) the properties you want to update
 *          example: {"aria-hidden":"true","style":"display:none;"}
 *
 * - classList:[] - list of strings you want to add/remove. The values you want to remove
 *          from the classList, start with exclamation mark.
 *          example: ["show","!hidden"] // will grant that "show" is present and "hidden" isn't.
 *
 * @param {HTMLElement} node
 * @returns
 */
export default (state, node) => {
    if (!isObject(state)) {
        console.warn("Missing state to render");
        return null;
    }
    return isHTMLElement(node) ? renderHTML(state, node) : renderObject(state);
};
